module.exports = __webpack_public_path__ + "img/diageo-distillery-building-site-2.80eb3bb5.png";